import { render, staticRenderFns } from "./ModuleTextEditor.vue?vue&type=template&id=4a1bfb88&scoped=true"
import script from "./ModuleTextEditor.vue?vue&type=script&lang=js"
export * from "./ModuleTextEditor.vue?vue&type=script&lang=js"
import style0 from "./ModuleTextEditor.vue?vue&type=style&index=0&id=4a1bfb88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1bfb88",
  null
  
)

export default component.exports